export enum WorkplaceAclRole {
	ADMIN = 'admin',
}
